module.exports = Object.freeze({
    API_URL: 'https://traineeship-backend.onrender.com',//'https://api.kidsandfun.be',
    // API_URL: 'http://localhost:2999',
    FRONT_URL:'https://www.kidsandfun.be',
    // FRONT_URL:'http://localhost:3000'
    FOLDER_PICTURE_ID:'1i6_tqAUucS8-RN37oNxUiHqQ2heDt46w',
    FOLDER_VIDEO_ID:'1spHn5crWpV8Mq8BkxOZve9WCrYFL6im-'
  });